import _ from 'lodash'
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FieldsRender from './FieldsRender.js'


class PBFormRender extends Component {

  _renderFormFields() {

    const { addonOps, state } = this.props;
    const { attr } = addonOps;

    if ( this.props.formName == 'mainForm' ) {
      var values = this.props.state.form.sppbForm.values;
    } else {
      var values = this.props.state.form.insideAddonForm.values;
    }

    let opsKeys = Object.keys(addonOps.attr);

    return(
        <Tabs defaultIndex={0} id="addon-option-form">
          <TabList>
          {
          opsKeys.map((tabName,index ) => {
              return(
                <Tab key={ index }>{tabName}</Tab>
            )})
          }
          </TabList>
          {
            opsKeys.map((tabName,index ) => {
                return(
                  <TabPanel key={ index }>
                    <div className="sppb-tab-pane">
                      <FieldsRender
                        fieldsAttr= { attr[tabName] }
                        values = { values }
                      />
                    </div>
                  </TabPanel>
              )})
            }
        </Tabs>
    )
  }

  render(){
    return(
      <div>
        <div className="sp-pagebuilder-fieldset">
          { this._renderFormFields() }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  };
}

export default connect(
  mapStateToProps
)(PBFormRender);



// WEBPACK FOOTER //
// ./src/helpers/form/PBFormRender.js